export default "../images/footer-image.svg?902ec07caadcbad804a97489ecc7c2d4";